import {UserSchema} from "../api";

export const formatDateTime = (dateTime: string) => {
    const date = new Date(Date.parse(dateTime));
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${minutes}`;
}

export const displayMatchStatus = (status: string) => {
    switch (status) {
        case 'NOT_STARTED':
            return 'Не начался';
        case 'LIVE':
            return 'Идёт игра';
        case 'CLOSED':
            return 'Закончен';
        default:
            return status
    }
}

export const displayUserName = (user: UserSchema) => {
    let name = '';
    if (user) {
        name = user.username;
        if (name) {
            return name;
        }
        name = user.email;
    }
    return name;
}